import { ReactNode, useMemo } from 'react';
import { Box, Stack } from '@mui/material';

import { ListFilterOption } from '@common/ui/ListFilters/common';
import ListFilterMultiSelect from '@common/ui/ListFilters/ListFilterMultiSelect';
import ListFilterSingleSelect from '@common/ui/ListFilters/ListFilterSingleSelect';

import AqlBuilderOperatorSelect from './AqlBuilderOperatorSelect';

import { AqlBuilderOperator, isFreeTextOperator } from '../helpers/common';

interface AqlBuilderFilterProps {
  operatorOptions: AqlBuilderOperator[];
  selectedOperator?: AqlBuilderOperator;
  onSelectOperator: (operator: AqlBuilderOperator) => void;
  valuesOptions: ListFilterOption[];
  selectedValues?: ListFilterOption[];
  onSelectValues: (value: ListFilterOption[]) => void;
  searchValue?: string;
  onSearchValue: (searchValue: string) => void;
  title?: ReactNode;
  width?: number;
  isFetching?: boolean;
  isLoading?: boolean;
  onBottomReached?: () => void;
}

export default function AqlBuilderSelect({
  operatorOptions,
  selectedOperator,
  onSelectOperator,
  valuesOptions,
  selectedValues,
  onSelectValues,
  searchValue,
  onSearchValue,
  title,
  width = 300,
  isFetching,
  isLoading,
  onBottomReached,
}: AqlBuilderFilterProps) {
  const freeTextOperator = useMemo(() => selectedOperator && isFreeTextOperator(selectedOperator), [selectedOperator]);

  return (
    <Box width={width}>
      <Stack direction="column" justifyContent="center" alignItems="stretch">
        {title}
        <AqlBuilderOperatorSelect options={operatorOptions} value={selectedOperator} onChange={onSelectOperator} />
        {freeTextOperator ? (
          <ListFilterSingleSelect
            options={valuesOptions}
            value={selectedValues?.[0]}
            onSelect={(v) => onSelectValues([v])}
            searchValue={searchValue}
            onSearch={onSearchValue}
            searchPlaceholder="Type value..."
            hiddenRadio
            isFetching={isFetching}
            isLoading={isLoading}
            onBottomReached={onBottomReached}
          />
        ) : (
          <ListFilterMultiSelect
            options={valuesOptions}
            value={selectedValues}
            onSelect={onSelectValues}
            searchValue={searchValue}
            onSearch={onSearchValue}
            isFetching={isFetching}
            isLoading={isLoading}
            onBottomReached={onBottomReached}
          />
        )}
      </Stack>
    </Box>
  );
}
